import React, { useEffect, useState } from 'react';
import { DOMAIN } from 'src/constants';

const PostSchemas = ({ post, author, validBreadcrumb }) => {
  const [text, setText] = useState('');

  const schemas = post?.acf?.schema
    ?.replace('<script type="application/ld+json">', '')
    .replace('</script>', '')
    .split('&&')
    .filter(Boolean);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = post?.content?.rendered || '';
      setText(tempDiv.textContent || tempDiv.innerText || '');
    }
  }, [post]);

  const renderAdditionalSchema = () => {
    if (!schemas || schemas.length === 0) return null;

    return schemas.map((s, index) => (
      <script
        key={index}
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: s,
        }}
      ></script>
    ));
  };
  
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `  
                {
                  "@context": "https://schema.org",
                  "@type": "Article",
                  "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "${post.link?.replace('https://vnrebates.net', DOMAIN)}"
                  },
                  "headline": "${post.title.rendered}",
                  "articleBody": "${text}",
                  "description": "${post.excerpt.rendered}",
                  "image": "${post?.thumbnail}",  
                  "author": {
                    "@type": "Person",
                    "name": "${author.name}",
                    "url": "${DOMAIN}/tac-gia/${author.slug}"
                  },  
                  "publisher": {
                    "@type": "Organization",
                    "name": "${DOMAIN}",
                    "logo": {
                      "@type": "ImageObject",
                      "url": "${DOMAIN}/images/logo.png"
                    }
                  },
                  "datePublished": "${post.date}",
                  "dateModified": "${post.last_modified}"
                }`,
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
            {
            "@context": "https://schema.org/", 
            "@type": "BreadcrumbList", 
            "itemListElement": [{
              "@type": "ListItem", 
              "position": 1, 
              "name": "Trang chủ",
              "item": "${DOMAIN}"  
            },{
              "@type": "ListItem", 
              "position": 2, 
              "name": "${validBreadcrumb[0]?.name}",
              "item": "${DOMAIN + validBreadcrumb[0]?.url}"  
            }${
              validBreadcrumb[1]
                ? `,{
              "@type": "ListItem", 
              "position": 3, 
              "name": "${validBreadcrumb[1]?.name}",
              "item": "${DOMAIN + validBreadcrumb[1]?.url}"  
            }`
                : ''
            }]
          }
          `,
        }}
      />

      {renderAdditionalSchema()}
    </>
  );
};
export default PostSchemas;
